import React from 'react'

import { makeStyles } from '@mui/styles'

import { QuizContextAction, QuizStoreContext } from '../../contexts/quizContext'

import { O, T } from '../../utils/Typography'
import { useWindowSize } from '../../utils/window'
import { OptionId, optionsDict } from '../../data/options'
import { shuffleArray } from '../../utils/functions'
import Slider from '@mui/material/Slider'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export type SliderQuestionProps = {
  options: Array<OptionId>
  currentQuizIndex: number
  questionText: string
  reduceQuizData: React.Dispatch<QuizContextAction>
}

const SliderQuestion: React.FC<SliderQuestionProps> = ({
  options,
  currentQuizIndex,
  questionText: label,
  reduceQuizData,
}) => {
  // console.log('SliderQuestion reload', options, currentQuizIndex, label)
  // const landscape = width > height;
  const { quizAnswers } = React.useContext(QuizStoreContext)
  const [sliderValue, setSliderValue] = React.useState<number>(3)

  //useLayoutEffect to update this before any rendering
  React.useLayoutEffect(() => {
    // console.log('quizAnswers', quizAnswers)
    const selectedSliderValue = options.findIndex(
      (option) => quizAnswers[currentQuizIndex][option] === true,
    )
    if (selectedSliderValue !== -1) {
      setSliderValue(selectedSliderValue)
    }
  }, [quizAnswers, currentQuizIndex, options])

  const handleChange = React.useCallback(
    (event: Event, value: number | number[], activeThumb: number) => {
      // console.log('handleChange', value)
      const newSliderValue: number = value as number

      // No change so just return
      if (newSliderValue === sliderValue) {
        return
      }

      reduceQuizData({
        type: 'update_quiz_answers_via_toggle',
        payload: {
          currentQuizIndex: currentQuizIndex,
          key: options[newSliderValue],
        },
      })
    },
    [currentQuizIndex, options, reduceQuizData, sliderValue],
  )

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: 'white',
        maxWidth: '1600px', // 3 columns
        width: '95%', // leaves some margin on sides}>
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        {/* {currentQuizIndex === 0 ? (
          <T style={{ maxWidth: 700, textAlign: "center" }}>
            👋<b>Note</b>: Please try to{" "}
            <b>focus on the art and not the individual cats</b> when answering
            these questions. Choose the piece of art that speaks to you, not the
            tabby cat that looks like yours. 😉 Don't overthink it—your first
            instincts are probably the most accurate!
          </T>
        ) : null} */}
        <T variant='h4' style={{ marginBottom: 5 }}>{`${
          currentQuizIndex + 1
        }. ${label}`}</T>
        <div style={{ height: 50 }} />
        <T variant='h4' style={{ marginBottom: 20, fontSize: '1.2rem' }}>
          <O>{optionsDict[options[sliderValue]]?.content}</O>
        </T>
        <br />

        <Box
          style={{
            height: 400,
            width: 400,
            marginTop: 20,
            marginBottom: 20,
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            display: 'flex',
          }}>
          <PrettoSlider
            aria-label='Presence'
            color='primary'
            defaultValue={sliderValue}
            getAriaValueText={(value: number, index: number) =>
              value.toString()
            }
            // orientation="vertical"
            value={sliderValue}
            onChange={handleChange}
            valueLabelDisplay='on'
            step={1}
            marks={options.slice(2).map((_, idx) => ({ value: idx + 1 }))}
            min={0}
            max={options.length - 1}
          />
        </Box>
      </div>
    </div>
  )
}

export default SliderQuestion

const PrettoSlider = styled(Slider)(({ theme }) => ({
  color: '#d9559d',
  height: 30,
  '& .MuiSlider-track': {
    border: 'none',
    borderRadius: 99,
  },
  '& .MuiSlider-dragging': {
    boxShadow: '0 0 0 10px rgba(217, 85, 157, 0.16)',
  },
  '& .MuiSlider-mark': {
    width: 1,
    height: 15,
    borderRadius: 99,
  },
  '& .MuiSlider-thumb': {
    height: 40,
    width: 40,
    backgroundColor: '#fff',
    // '&:hover': {
    //   boxShadow: '0 0 0 10px rgba(217, 85, 157, 0.16)',
    // },
  },
  '& .MuiSlider-rail': {
    //   color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    //   opacity: theme.palette.mode === 'dark' ? undefined : 1,
    //   height: 3,
    borderRadius: 99,
  },
  //   border: '2px solid currentColor',
  //   '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
  //     boxShadow: 'inherit',
  //   },
  //   '&:before': {
  //     display: 'none',
  //   },
  // },
  '& .MuiSlider-valueLabel': {
    //   lineHeight: 1.2,
    //   fontSize: 12,
    //   background: 'unset',
    //   padding: 0,
    //   width: 32,
    //   height: 32,
    //   borderRadius: '50% 50% 50% 0',
    // backgroundColor: '#04bf8a',
    //   transformOrigin: 'bottom left',
    //   transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    //   '&:before': { display: 'none' },
    //   '&.MuiSlider-valueLabelOpen': {
    //     transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    //   },
    //   '& > *': {
    //     transform: 'rotate(45deg)',
    //   },
  },
}))
